import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";

const FetchSubSystems = (props) => {
  const [systemId, setSystemId] = useState(null);
  const queryParams = new URLSearchParams(window.location.search);
  const accessToken = queryParams.get("userAuthToken");

  useEffect(() => {
    setSystemId(props.serviceComponentId);
  }, [props.value, props.serviceComponentId])

  const loadOptions = async (searchQuery, _, { page }) => {

    const response = await fetch(
      `/api/v1/service_codes/aar/sub_systems?service_component=${systemId ? systemId : ''}&search=${searchQuery}&page=${page}`, {
      method: 'GET',
      headers: {
        'Access-Token': accessToken,
      },
    }
    );
    const responseJSON = await response.json();

    let options = responseJSON.sub_service_components.map((option) => ({
      label: `${option.name}`,
      value: `${option.id}`,
      data: option
    }))

    return {
      options: options,
      hasMore: responseJSON.meta.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: props.showError ? '#ff0000' : '#cccccc',
    }),
  };

  return (
    <>
    {typeof (props.value) === 'string' ?
        <AsyncPaginate
          key={JSON.stringify(systemId)}
          defaultValue={{ value: props.value, label: props.value }}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Please select"
          isClearable={true}
          debounceTimeout={500}
          className='service_dropdown async-dd'
          additional={{
            page: 1,
          }}
        /> :
        <AsyncPaginate
          key={JSON.stringify(systemId)}
          value={props.value}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Please select"
          className='service_dropdown async-dd'
          isClearable={true}
          debounceTimeout={500}
          styles={customStyles}
          additional={{
            page: 1,
          }}
        />
      }
    </>
  );
};

FetchSubSystems.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default FetchSubSystems;
